import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../globalInspector/axiosInstance";
import { env } from "../../../../env";
import CommonToast from "../../../../components/_utils/CommonToast";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
const baseUrl = env.REACT_APP_BASE_URL;

export const getAllFieldForceAccount = createAsyncThunk(
  "getAllFieldForceAccount",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_size,
      approval_status,
      start_date,
      end_date,
      bank_account_no,
      field_force_custom_limit,
      ifsc,
      pan,
      entity_id,
      category,
      amount,
      search_string,
      labels,
      associate,
    } = values;
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/field_force`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: page_no ? page_no : undefined,
            page_size: page_size ? page_size : undefined,
            ...((approval_status || associate) && {
              approval_status: associate ? associate : [approval_status],
            }),
            start_date: start_date,
            end_date: end_date,
            bank_account_no: bank_account_no,
            field_force_custom_limit: field_force_custom_limit,
            ifsc: ifsc,
            pan: pan,
            entity_id: entity_id,
            category: category,
            search_string: search_string,
            amount: amount,
            labels: labels,
          },
        },
      );
      return response.data;
    } catch (error) {
      // return rejectWithValue(error?.response?.data?.error?.base?.[0] ||
      //   error?.response?.data?.error ||
      //   error?.response?.data?.message ||
      //   error?.message ||
      //   "An unknown error occurred");

      if (error?.response?.data?.errors?.base?.[0]) {
        CommonToast({
          text: error?.response?.data?.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      if (error?.response?.data?.errors?.user_unauthorized?.[0]) {
        CommonToast({
          text: error.response.data.errors.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const createFieldForceAccount = createAsyncThunk(
  "createFieldForceAccount",
  async (values, { rejectWithValue }) => {
    const {
      bank_account,
      contact_no,
      email_id,
      gstin,
      ifsc_code,
      panNumber,
      categories,
      navigate,
      account_name,
      labels,
      recipient_email,
      amount,
      linked_user_id,
      virtual,
    } = values;

    const requestBody = {
      field_force_accounts: {
        bank_account_no: bank_account,
        contact_no,
        email: email_id,
        gstin,
        ifsc: ifsc_code,
        pan: panNumber,
        name: account_name,
        labels,
        category: categories?.length ? categories : null,
        recipient_email,
        field_force_custom_limit: amount,
        linked_user_id: linked_user_id,
        virtual,
      },
    };

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/accounts/field_force`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const responseData = error.response?.data;
      // let errorMessage = "Something went wrong";
      // let isArrayError = false;

      if (responseData?.errors?.user_unauthorized) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "FFUAccount" },
        });
        return rejectWithValue("User unauthorized");
      }

      // const errs = responseData?.errors;

      // if (errs) {
      //   if (errs?.bank_account_number) {
      //     isArrayError = true;

      //     errorMessage = JSON.stringify({
      //       type: "array",
      //       errorData: [
      //         errs?.bank_account_number?.[0],
      //         errs?.permanent_account_number?.[0],
      //       ],
      //     });
      //   } else {
      //     errorMessage =
      //       errs?.category?.[0] ||
      //       errs?.[0]?.gstin_detail?.base ||
      //       errs?.base?.[0] ||
      //       responseData?.message ||
      //       error.message;
      //   }
      // } else if (error.response?.statusText) {
      //   errorMessage = error.response.statusText;
      // }

      // // Toast handling
      // if (isArrayError) {
      //   try {
      //     const { errorData } = JSON.parse(errorMessage);

      //     errorData?.forEach(
      //       (msg) =>
      //         msg &&
      //         CommonToast({
      //           text: msg,
      //           icon: ICONS?.ERROR_WHITE_CIRCLE,
      //           variant: "var(--error)",
      //           btnProps: {
      //             isDisabled: false,
      //             enabledTextColor: "var(--text-primary)",
      //             enabledBgColor: "var(--primary-bg)",
      //           },
      //         }),
      //     );
      //   } catch {
      //     CommonToast({
      //       text: "Unexpected error format",
      //       icon: ICONS?.ERROR_WHITE_CIRCLE,
      //       variant: "var(--error)",
      //       btnProps: {
      //         isDisabled: false,
      //         enabledTextColor: "var(--text-primary)",
      //         enabledBgColor: "var(--primary-bg)",
      //       },
      //     });
      //   }
      // } else {
      //   CommonToast({
      //     text: errorMessage,
      //     icon: ICONS?.ERROR_WHITE_CIRCLE,
      //     variant: "var(--error)",
      //     btnProps: {
      //       isDisabled: false,
      //       enabledTextColor: "var(--text-primary)",
      //       enabledBgColor: "var(--primary-bg)",
      //     },
      //   });
      // }

      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getSpecificFieldForceAccount = createAsyncThunk(
  "getSpecificFieldForceAccount",
  async (payload, { rejectWithValue }) => {
    const { id } = payload;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/field_force/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.errors ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(error);
    }
  },
);

export const editFieldForceAccount = createAsyncThunk(
  "editFieldForceAccount",
  async (values, { rejectWithValue }) => {
    const {
      id,
      pan,
      contact_no,
      email,
      gstin,
      category,
      name,
      recipient_email,
      linked_user_id,
    } = values;

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/field_force/${id}/edit_other_details`,
        {
          field_force_accounts: {
            pan,
            email,
            contact_no,
            gstin,
            category,
            name,
            recipient_email,
            ...(linked_user_id !== undefined && {
              linked_user_id: linked_user_id || null,
            }),
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const archiveFieldForceAccount = createAsyncThunk(
  "archiveFieldForceAccount",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/field_force/${id}/archive`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.errors ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const unarchiveFieldForceAccount = createAsyncThunk(
  "unarchiveFieldForceAccount",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/field_force/${id}/unarchive`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.errors ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const addNewLabel = createAsyncThunk(
  "addNewLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("AvailableLabels") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("AvailableLabels", payload);

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base?.[0]) {
        CommonToast({
          text: error?.response?.data?.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      if (error?.response?.data?.errors?.user_unauthorized?.[0]) {
        CommonToast({
          text: error.response.data.errors.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const removeNewLabel = createAsyncThunk(
  "removeNewLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/beneficiary/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else {
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);
export const filedForceRequiredApproval = createAsyncThunk(
  "filedForceRequiredApproval",
  async (values) => {
    const {
      page_no,
      page_size,
      categoryName,
      search_string,
      bank_account_no,
      ifsc,
      start_date,
      end_date,
      pan,
      labels,
      recipient_email,
      entity_id,
    } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/field_force`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            approval_status: ["pending"],
            page_no: page_no,
            page_size: page_size,
            category: categoryName,
            search_string: search_string,
            start_date,
            end_date,
            bank_account_no: bank_account_no,
            ifsc: ifsc,
            pan: pan,
            labels: labels,
            recipient_email: recipient_email,
            entity_id: entity_id,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const filedForceApproval = createAsyncThunk(
  "filedForceApproval",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/field_force/${id}/approve`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        return rejectWithValue(undefined);
      }

      const errData = error?.response?.data || {
        status: false,
        message: "Something went wrong",
      };

      return rejectWithValue(errData);
    }
  },
);

export const filedForceDeniedAccount = createAsyncThunk(
  "filedForceDeniedAccount",
  async ({ id, AccountIdData }, { rejectWithValue }) => {
    try {
      const data = {
        rejection_reason: AccountIdData,
      };

      const response = await axiosInstance.put(
        `${baseUrl}/accounts/field_force/${id}/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return undefined;
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

const fieldForceAccount = createSlice({
  name: "fieldForceAccount",
  initialState: {
    toggleFfa: false,
    storedPage: 1,

    allfieldForceAccountData: [],
    allfieldForceAccountLoading: false,
    allfieldForceAccountError: false,

    createFieldForceAccountData: [],
    createFieldForceAccountLoading: null,
    createFieldForceAccountError: null,

    fieldforceRequiredApprovalData: null,
    fieldforceRequiredApprovalLoading: null,
    fieldforceRequiredApprovalError: null,

    fieldforceWaitingApprovalData: null,
    fieldforceWaitingApprovalLoading: null,
    fieldforceWaitingApprovalError: null,

    fieldforceDeniedApprovalData: null,
    fieldforceDeniedApprovalLoading: null,
    fieldforceDeniedApprovalError: null,

    getSpecificFieldForceAccountLoading: null,
    getSpecificFieldForceAccountError: null,
    getSpecificFieldForceAccountData: null,
  },
  reducers: {
    setToggleFfa: (state, action) => {
      state.toggleFfa = action.payload;
    },
    resetToggleFfa: (state) => {
      state.toggleFfa = false;
    },
    resetpage: (state) => {
      state.storedPage = 1;
    },
    setStoredPage: (state, action) => {
      state.storedPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllFieldForceAccount.pending, (state) => {
      state.allfieldForceAccountLoading = true;
    });
    builder.addCase(getAllFieldForceAccount.fulfilled, (state, action) => {
      state.allfieldForceAccountLoading = false;
      state.allfieldForceAccountData = action.payload;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabelsPvt",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
    });
    builder.addCase(getAllFieldForceAccount.rejected, (state, action) => {
      state.fieldforceRequiredApprovalError = true;
      state.fieldforceRequiredApprovalLoading = false;
    });

    builder.addCase(filedForceRequiredApproval.pending, (state, action) => {
      state.fieldforceRequiredApprovalLoading = true;
    });
    builder.addCase(filedForceRequiredApproval.fulfilled, (state, action) => {
      state.fieldforceRequiredApprovalLoading = false;
      state.fieldforceRequiredApprovalData = action.payload;
    });
    builder.addCase(filedForceRequiredApproval.rejected, (state, action) => {
      state.fieldforceRequiredApprovalError = true;
      state.fieldforceRequiredApprovalData = null;
    });

    builder.addCase(filedForceDeniedAccount.pending, (state, action) => {
      state.fieldforceDeniedApprovalLoading = true;
    });
    builder.addCase(filedForceDeniedAccount.fulfilled, (state, action) => {
      state.fieldforceDeniedApprovalLoading = false;
      state.fieldforceDeniedApprovalData = action.payload;
    });
    builder.addCase(filedForceDeniedAccount.rejected, (state, action) => {
      state.fieldforceDeniedApprovalError = true;
      state.fieldforceDeniedApprovalData = null;
      state.fieldforceDeniedApprovalLoading = false;
    });

    builder.addCase(filedForceApproval.pending, (state, action) => {
      state.fieldforceWaitingApprovalLoading = true;
    });
    builder.addCase(filedForceApproval.fulfilled, (state, action) => {
      state.fieldforceWaitingApprovalLoading = false;
      state.fieldforceWaitingApprovalData = action.payload;
    });
    builder.addCase(filedForceApproval.rejected, (state, action) => {
      state.fieldforceWaitingApprovalError = true;
      state.fieldforceWaitingApprovalData = null;
      state.fieldforceWaitingApprovalLoading = false;
    });
    builder.addCase(createFieldForceAccount.pending, (state) => {
      state.createFieldForceAccountLoading = true;
    });
    builder.addCase(createFieldForceAccount.fulfilled, (state, action) => {
      state.createFieldForceAccountLoading = false;
      state.createFieldForceAccountData = action.payload;
    });
    builder.addCase(createFieldForceAccount.rejected, (state) => {
      state.createFieldForceAccountError = true;
      state.createFieldForceAccountLoading = false;
    });

    builder.addCase(getSpecificFieldForceAccount.pending, (state) => {
      state.getSpecificFieldForceAccountLoading = true;
      state.getSpecificFieldForceAccountError = false;
    });
    builder.addCase(getSpecificFieldForceAccount.fulfilled, (state, action) => {
      state.getSpecificFieldForceAccountLoading = false;
      state.getSpecificFieldForceAccountData = action.payload;
    });
    builder.addCase(getSpecificFieldForceAccount.rejected, (state) => {
      state.getSpecificFieldForceAccountError = true;
      state.getSpecificFieldForceAccountLoading = false;
    });
  },
});

export const { setStoredPage, setToggleFfa, resetToggleFfa } =
  fieldForceAccount.actions;

export default fieldForceAccount.reducer;
